import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./LegalPages.css";

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="page-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} /> Retour
          </button>
          <h1 className="heading-lg">Politique de Confidentialité</h1>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p className="body-md">
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
            </p>

            <h2 className="heading-md">1. Introduction</h2>
            <p className="body-md">
              Sharp Physio s'engage à protéger la confidentialité de vos données
              personnelles. Cette politique explique comment nous collectons,
              utilisons et protégeons vos informations.
            </p>

            <h2 className="heading-md">2. Données collectées</h2>
            <p className="body-md">
              Notre site web collecte uniquement les données nécessaires pour
              améliorer votre expérience :
            </p>
            <ul className="body-md">
              <li>Cookies techniques pour le fonctionnement du site</li>
              <li>Données de navigation anonymes à des fins d'analyse</li>
            </ul>

            <h2 className="heading-md">3. Utilisation de Doctolib</h2>
            <p className="body-md">
              Les prises de rendez-vous sont gérées par Doctolib. Lorsque vous
              cliquez sur notre lien Doctolib, vous êtes redirigé vers leur
              plateforme sécurisée qui possède sa propre politique de
              confidentialité.
            </p>

            <h2 className="heading-md">4. Vos droits</h2>
            <p className="body-md">
              Conformément au RGPD, vous disposez d'un droit d'accès, de
              rectification et de suppression de vos données. Pour exercer ces
              droits, contactez-nous à contact@sharpphysio.fr
            </p>

            <h2 className="heading-md">5. Sécurité</h2>
            <p className="body-md">
              Nous mettons en œuvre des mesures de sécurité appropriées pour
              protéger vos données contre tout accès non autorisé.
            </p>

            <h2 className="heading-md">6. Contact</h2>
            <p className="body-md">
              Pour toute question concernant cette politique, contactez-nous : 
              <br />
              Email : contact@sharpphysio.fr
              <br />
              Téléphone : +33 1 23 45 67 89
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
